<template>
  <div>
    <core-logo class="mx-auto max-w-[184px] mb-4" />
    <h1 class="text-center font-serif  text-3xl sm:text-4xl mb-1"><slot name="heading" /></h1>
    <p class="text-center text-xl text-gray-600" v-if="$slots.content"><slot name="content" /></p>
  </div>
</template>
